import QrScannerWithPermission from './QrScannerWithPermission'

export default QrScannerWithPermission
